/** @jsx jsx */
import { gql } from '@apollo/client';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';
import Video, { VideoFragment } from '../Video/Video';

export default function ProductVideos({ product, ...rest }) {
  if (!product?.videos?.length) return null;
  const needsTitle = !product.videos[0]?.title;
  return (
    <Section title={needsTitle && <Trans>Videos</Trans>} {...rest}>
      {product.videos.map((video) => (
        <Video key={video?.videoId} {...video} />
      ))}
    </Section>
  );
}

export const fragment = graphql`
  fragment ProductVideos on Product {
    videos {
      type
      videoId
      title
      ...Video
    }
  }
`;

export const ProductVideosFragment = gql`
  ${VideoFragment}
  fragment ProductVideos on Product {
    videos {
      type
      videoId
      title
      ...Video
    }
  }
`;
